export { TextareaAutosize as default } from '@mui/base/TextareaAutosize';